import React, { useState, useEffect } from 'react';
import Image from '../../../components/AppImage';

const HeroSection = () => {
  const [currentText, setCurrentText] = useState(0);
  const animatedTexts = [
    "33 Years of Leadership Excellence",
    "Empowering Youth Through Service",
    "Building Tomorrow's Leaders Today",
    "Serving Communities with Purpose"
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentText((prev) => (prev + 1) % animatedTexts.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <Image
          src="/assets/images/banner/about_us1.jpg"
          alt="Leo Club of Colombo Circle Heritage"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center text-white">
        <div className="space-y-8">
          <div className="inline-flex items-center px-6 py-3 bg-white/10 backdrop-blur-sm rounded-full text-sm font-medium border border-white/20">
            <span className="w-2 h-2 bg-secondary rounded-full mr-3 animate-pulse"></span>
            Est. 1991 • Lions International Charter
          </div>
          
          <h1 className="text-5xl lg:text-7xl font-bold leading-tight">
            Leo Club of
            <span className="block text-secondary">Colombo Circle</span>
          </h1>
          
          <div className="h-16 flex items-center justify-center">
            <p className="text-2xl lg:text-3xl font-semibold text-secondary transition-all duration-1000 ease-in-out transform">
              {animatedTexts[currentText]}
            </p>
          </div>
          
          <p className="text-xl lg:text-2xl text-white/90 leading-relaxed max-w-4xl mx-auto">
            From humble beginnings at Bambalapitya Hindu College to becoming one of Sri Lanka's most outstanding Leo clubs, 
            we've been shaping leaders and serving communities for over three decades.
          </p>
          
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mt-12">
            <div className="text-center">
              <div className="text-4xl font-bold text-secondary">33+</div>
              <div className="text-sm text-white/80 mt-1">Years of Service</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-secondary">500+</div>
              <div className="text-sm text-white/80 mt-1">Projects Completed</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-secondary">15+</div>
              <div className="text-sm text-white/80 mt-1">District Awards</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-secondary">2</div>
              <div className="text-sm text-white/80 mt-1">Leo of the World</div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/70 rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;